import type { SuperHubRouteParams } from '@routes/SuperHub/types';

import { matchPath } from 'react-router-dom';

import { SuperHubRoutePaths } from '@routes/SuperHub/types';

/**
 * Determines if a given href matches a react-router route for Superhub's browser router.
 * If it is valid, the cleaned path is returned (with the baseUrl removed if present).
 * If the href does not match any browser router paths, null is returned.
 *
 * @example
 * const currentPath = getBrowserRouterPath('/project/docs/foo', '/project');
 * console.log(currentPath); // e.g. "/docs/foo"
 * const invalidPath = getBrowserRouterPath('/external-link', '/project');
 * console.log(invalidPath); // null
 */
export default function getBrowserRouterPath(href: string, baseUrl: string = '') {
  // The Hub's browser router `basename` option is set with the `baseUrl` value and will handle links
  // with that `basename` segment in the href. So we need to clean it from the href before
  // matching the path to avoid false negative matches.
  let cleanHref = baseUrl === '/' ? href : href.replace(baseUrl, '');
  // Remove any query params before matching
  cleanHref = cleanHref.split(/[?]/)[0];
  const isMatch = matchPath<SuperHubRouteParams>(cleanHref, Object.values(SuperHubRoutePaths));
  return isMatch ? cleanHref : null;
}
